import { Shield, CalendarCheck, FileStack, Globe, BrainCircuit, Scale } from 'lucide-react';
import AnimateIn from './AnimateIn';

const trustPoints = [
  { icon: Shield, title: 'Built for England PRS', desc: 'Designed specifically for the England private rented sector.' },
  { icon: CalendarCheck, title: 'Date-aware guidance', desc: 'Information is tied to relevant dates and current regulations.' },
  { icon: FileStack, title: 'Evidence-first workflows', desc: 'Every action creates a clear, timestamped record.' },
  { icon: Globe, title: 'Multilingual-ready', desc: 'Supporting diverse households with accessible guidance.' },
  { icon: BrainCircuit, title: 'AI is assistive', desc: 'AI supports your workflow. It is not a substitute for legal advice.' },
  { icon: Scale, title: 'Not a law firm', desc: 'ActCheck provides information support, not legal representation.' },
];

export default function TrustSection() {
  return (
    <section data-testid="trust-section" className="py-20 sm:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <AnimateIn>
          <div className="text-center mb-14">
            <span className="inline-block text-compliance-green font-body font-semibold text-sm tracking-wide uppercase mb-3">
              Trust & Clarity
            </span>
            <h2 className="font-heading font-bold text-3xl sm:text-4xl text-ink mb-4">
              Built with compliance and clarity at the core
            </h2>
            <p className="text-slate-text font-body text-lg max-w-2xl mx-auto">
              ActCheck is designed to be clear, transparent, and trustworthy from the ground up.
            </p>
          </div>
        </AnimateIn>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {trustPoints.map((t, i) => (
            <AnimateIn key={t.title} delay={i * 80}>
              <div
                data-testid={`trust-point-${i}`}
                className="flex gap-4 p-5 rounded-xl bg-mist hover:bg-white hover:shadow-sm border border-transparent hover:border-gray-100 transition-all duration-300"
              >
                <div className="w-10 h-10 rounded-lg bg-navy/5 flex items-center justify-center flex-shrink-0">
                  <t.icon size={20} className="text-navy" />
                </div>
                <div>
                  <h3 className="font-heading font-bold text-[15px] text-ink mb-1">{t.title}</h3>
                  <p className="font-body text-sm text-slate-text leading-relaxed">{t.desc}</p>
                </div>
              </div>
            </AnimateIn>
          ))}
        </div>
      </div>
    </section>
  );
}
